import styled from 'styled-components';
import { rem, em } from 'polished';
import { colors } from 'core/theme';

export const StyledWrapper = styled.div`
  position: relative;
`;

export const StyledContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;

  .pika-single {
    background: ${colors.background};
    border: 1px solid ${colors.hairline};
    color: ${colors.text};
    font-family: inherit;
    font-size: ${rem(14)};
    font-weight: 500;
    width: ${em(270, 14)};

    position: absolute !important;
    top: 1em !important;
    left: 0 !important;
    z-index: 500;
  }
  .pika-single.is-bound {
    box-shadow: none;
  }

  .pika-lendar {
    margin: 0;
    padding: 1em;
    width: 100%;
  }

  .pika-select {
    font-size: 1em;

    select {
      font-family: inherit;
    }

    option {
      color: ${colors.text};
      background-color: ${colors.background};
      margin: 1em 0;
    }
  }

  .pika-label {
    font-size: ${em(14, 14)};
    font-weight: 500;
    color: ${colors.text};
    background-color: ${colors.background};

    &::after {
      content: '▾';
      color: ${colors.lightText};
    }

    &:first-child {
      margin-right: 0.5em;
    }
  }

  .pika-prev,
  .is-rtl .pika-next {
      background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSI3LjQxcHgiIGhlaWdodD0iMTJweCIgdmlld0JveD0iMCAwIDcuNDEgMTIiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDcuNDEgMTIiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHBhdGggZD0iTTcuNDEsMS40MUw2LDBMMCw2bDYsNmwxLjQxLTEuNDFMMi44Myw2TDcuNDEsMS40MXoiLz4NCjwvc3ZnPg0K');
      background-size: 0.75em;
  }

  .pika-next,
  .is-rtl .pika-prev {
      background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSI3LjQxcHgiIGhlaWdodD0iMTJweCIgdmlld0JveD0iMCAwIDcuNDEgMTIiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDcuNDEgMTIiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHBhdGggZD0iTTQuNTgsNkwwLDEwLjU5TDEuNDEsMTJsNi02bC02LTZMMCwxLjQxTDQuNTgsNnoiLz4NCjwvc3ZnPg0K');
      background-size: 0.75em;
  }

  .is-today .pika-button {
    color: ${colors.primary};
  }

  .pika-table abbr {
    cursor: default;
    color: ${colors.lightText};
    font-size: ${em(12, 14)};
    text-decoration: none;
    text-transform: none;
  }

  .pika-table th {
    color: ${colors.text};
    font-size: ${em(14, 14)};
    line-height: 1;
    font-weight: 500;
    padding: 0.5em 0 1em;
    text-align: center;
  }

  .pika-table th,
  .pika-table td {
    width: auto;
  }

  .pika-button {
    background: transparent;
    color: ${colors.text};
    font-size: ${em(14, 14)};
    text-align: center;
    width: ${em(32, 14)};
    height: ${em(32, 14)};
  }

  .is-selected .pika-button,
  .has-event .pika-button {
    color: ${colors.background};
    background: ${colors.primary};
    border-radius: 0;
    box-shadow: none;
  }

  .pika-button:hover,
  .pika-row.pick-whole-week:hover .pika-button {
      color: ${colors.background};
      background: ${colors.primaryLight};
      border-radius: 0;
  }
`;

export const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 5;
  height: 100%;

  & > button {
    height: 100%;
    padding: 0 0.5em;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Rezultati/components/DateInput/styled.js